import countriesData from '@/data/countries.json'

export interface CountryInfo {
  name: string
  name_ru: string
  flag_code: string
}

const countries = countriesData as Record<string, CountryInfo>

export function resolveCountryCode(countryCode?: string | null, fallbackLocation?: string | null): string {
  const cc = (countryCode || '').trim().toUpperCase()
  if (cc && countries[cc]) return cc
  const loc = (fallbackLocation || '').trim().toUpperCase()
  if (loc.length === 2 && countries[loc]) return loc
  return cc || loc
}

export function countryName(countryCode?: string | null, lang: 'ru' | 'en' = 'ru', fallbackLocation?: string | null): string {
  const code = resolveCountryCode(countryCode, fallbackLocation)
  const entry = code ? countries[code] : undefined
  if (entry) return lang === 'ru' ? entry.name_ru || entry.name : entry.name
  return (fallbackLocation || countryCode || '').trim()
}

export function flagSvgUrl(countryCode?: string | null, flagCode?: string | null, fallbackLocation?: string | null): string {
  const code = resolveCountryCode(countryCode, fallbackLocation)
  const entry = code ? countries[code] : undefined
  const fileCode = (flagCode || entry?.flag_code || code || '').toUpperCase()
  if (!fileCode) return ''
  const base = import.meta.env.BASE_URL || '/'
  return `${base}assets/images/flags/${fileCode}.svg`
}

export function locationParts(
  countryCode?: string | null,
  fallbackLocation?: string | null,
  lang: 'ru' | 'en' = 'ru',
  flagCode?: string | null,
) {
  return {
    name: countryName(countryCode, lang, fallbackLocation),
    flagUrl: flagSvgUrl(countryCode, flagCode, fallbackLocation),
    countryCode: resolveCountryCode(countryCode, fallbackLocation),
  }
}
